import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Space, Typography, Form, Input, Button, Select, Table, AutoComplete, message } from 'antd'
import { reqGwasTraitsInfo, reqGwasVariantsInfo, reqGwasChrInfo, reqSearchGwas } from '../../api'

const { Paragraph } = Typography
const { Option } = Select

class SearchGwas extends React.Component {
    state = {
        // form 表单状态
        population: '',
        trait: '',
        trait_options: '',
        variant_id: '',
        variant_options: '',
        loc_chr: '',
        chr_options: '',
        loc_start: '',
        loc_end: '',
        pvalue_start: '',
        pvalue_end: '',
        disabled: false,    // 控制submit按钮的可用状态
        // 结果table状态 
        title: '',
        loading: false,
        has_data: false,
        searchResult: '',
        pagination: {
            current: '',
            pageSize: '',
            total: '',
            showSizeChanger: false,
            showQuickJumper: true
        }
    }
    
    formRef = React.createRef()

    onFinish = async (values) => {
        const { population, trait, variant_id, loc_chr, loc_start, loc_end, pvalue_start, pvalue_end } = values
        
        this.setState({
            disabled: true,
            loading: true
        })

        const param = {
	        search_type: 'search_gwas',
            population: population,
            trait: trait,
            snpid: variant_id,
            chr: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            log_pvalue__gte: pvalue_start,
            log_pvalue__lt: pvalue_end,
            page: 1
        }
        const searchResult = await reqSearchGwas(param)
        let table_title = ''
        if (searchResult.code ===0 ) {
            table_title = () => {
                return <span><b>{searchResult.data.count}</b> records were returned.</span>
            }

            this.setState({
                population: population,
                trait: trait,
                variant_id: variant_id,
                loc_chr: loc_chr,
                loc_start: loc_start,
                loc_end: loc_end,
                pvalue_start: pvalue_start,
                pvalue_end: pvalue_end,
                disabled: false,
                title: table_title,
                loading: false,
                has_data: true,
                searchResult: searchResult.data,
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    onPopulationChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            trait: '',
            variant_id: '',
            loc_chr: ''
        })
        this.setState({
            trait_options: [],
            variant_options: [],
            chr_options: []
        })

        if (val) {
            const traits_results = await reqGwasTraitsInfo(val)
            const chr_results = await reqGwasChrInfo(val)
            let trait_options = ''
            let chr_options = ''
            if (traits_results.code === 0) {
                let data = traits_results.data
                for (let v of data) {
                    v['value'] = v['trait']
                    v['label'] = v['trait']
                }
                trait_options = data
            }

            if (chr_results.code === 0) {
                let data = chr_results.data
                for (let v of data) {
                    v['value'] = v['chr']
                    v['label'] = v['chr']
                }
                chr_options = data
            }

            this.setState({
                population: val,
                trait_options: trait_options,
                chr_options: chr_options
            })
        }

        this.setState({
            population: val
        })
    }

    onTraitChange = async (val) => {
        this.formRef.current.setFieldsValue({ 
            variant_id: '',
        })
        this.setState({
            variant_options: []
        })
        
        if (this.state.population && val) {
            const results = await reqGwasVariantsInfo(this.state.population, val)
            let variant_options = ''
            if (results.code === 0) {
                let data = results.data
                for (let v of data) {
                    v['value'] = v['snpid']
                    v['label'] = v['snpid']
                }
                variant_options = data
            }
        
            this.setState({
                trait: val,
                variant_options: variant_options
            })
        }
        
        this.setState({
            dataset: val
        })
    }

    //分页、排序、筛选变化时触发
    onTableChange = async (pagination, filters, sorter) => {
        const { population, trait, variant_id, loc_chr, loc_start, loc_end, pvalue_start, pvalue_end } = this.state
        const { current } = pagination
        const param = {
            population: population,
            trait: trait,
            snpid: variant_id,
            chr: loc_chr,
            posi__gte: loc_start,
            posi__lt: loc_end,
            log_pvalue__gte: pvalue_start,
            log_pvalue__lt: pvalue_end,
            page: current
        }
        const searchResult = await reqSearchGwas(param)
        if (searchResult.code === 0) {
            this.setState({
                searchResult: searchResult.data,
                pagination: {
                    current: current,
                    pageSize: 10,
                    total: searchResult.data.count,
                    showSizeChanger: false,
                    showQuickJumper: true
                }
            })
        } else {
            message.error('Request failed. ' + searchResult.message)
        }
    }

    // 表单重置
    onReset = () => {
        this.formRef.current.resetFields()
        this.setState({
            trait_options: [],
            variant_options: [],
            chr_options: []
        })
    }

    render() {
        const { trait_options, variant_options, chr_options, disabled, title, loading, has_data, searchResult, pagination } = this.state
        
        const layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 6 },
            colon: false
        }
        const tailLayout = {
            wrapperCol: { offset: 4, span: 12 },
        }

        const columns = [
            {
                title: 'Trait',
                dataIndex: 'trait',
            },
            {
                title: 'Variant ID',
                dataIndex: 'snpid',
            },
            {
                title: 'Chr',
                dataIndex: 'chr',
            },
            {
                title: 'Position',
                dataIndex: 'posi',
            },
            {
                title: 'P-value(-log10)',
                dataIndex: 'log_pvalue',
            },
            {
                title: 'Ref',
                dataIndex: 'ref_allele',
                width: 50,
            },
            {
                title: 'Alt',
                dataIndex: 'alt',
                width: 50,
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'operation',
                render: (item) => {
                    const gwasviz_link = `/tool/gwas_single_trait/${item.population}/${item.trait}/${item.chr}/${item.posi-50000}/${item.posi+50000}`
                    return (<Link to={ gwasviz_link } target="_blank"><Button type="primary" size="small" className="gwasviz-action">GWAS Visualizer</Button></Link>)
                }
            }
        ]

        if (searchResult) {
            for (let v of searchResult.results){
                v['key'] = v['trait'] + '-' + v['snpid']
            }
        }

        return (
            <React.Fragment>
                <Form {...layout} name="search-gwas" ref={this.formRef} className="search-gwas-form" onFinish={this.onFinish}>
                    <Paragraph>
                        Search for genetic loci significantly related to phenotype traits and metabolites by trait name, variant ID, physical location and significant P values.<br />
                        For example: trait: 1nitro2phenylethane, variant ID: 4_56452591.
                    </Paragraph>
                    <Form.Item name="population" label="Population" rules={[{ required: true }]}>
                        <Select placeholder="Select population" showArrow allowClear onChange={this.onPopulationChange}>
                            <Option value="Pop332">Pop332</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item name="trait" label="Trait">
                        <AutoComplete 
                            allowClear
                            placeholder=""
                            style={{width: 300}}
                            options={trait_options}
                            onChange={this.onTraitChange}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item name="variant_id" label="Variant ID">
                        <AutoComplete 
                            allowClear
                            placeholder="e.g. 4_56452591"
                            style={{width: 300}}
                            options={variant_options}
                            filterOption={(inputValue, option) =>
                                option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                        />
                    </Form.Item>
                    <Form.Item label="Chromosome" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="loc_chr">
                                            <AutoComplete 
                                                allowClear
                                                placeholder="e.g. 11"
                                                style={{width: 150}}
                                                options={chr_options}
                                                filterOption={(inputValue, option) =>
                                                    option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                           />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 12847132" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="loc_end" label="and" 
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^\d+$/,
                                                    message: 'must be a number.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="location end position" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item label="P-value(-log10)" wrapperCol={{span: 18}}>
                        <Row>
                            <Col span={24}>
                                <Space>
                                    <Col>
                                        <Form.Item name="pvalue_start" label="between"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 3.2988193156177" />
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item name="pvalue_end" label="and"
                                            rules={[
                                                { 
                                                    type: 'string',
                                                    pattern: /^(\-|\+)?\d+(\.\d+)?$/,
                                                    message: 'must be a number or float.'
                                                }
                                            ]}
                                        >
                                            <Input placeholder="e.g. 4.16282251931012" />
                                        </Form.Item>
                                    </Col>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                    <Form.Item {...tailLayout}>
                        <Row>
                            <Col span={12}>
                                <Space>
                                    <Button type="primary" disabled={disabled} htmlType="submit" block>
                                        Submit
                                    </Button>
                                    <Button htmlType="button" disabled={disabled} onClick={this.onReset}>
                                        Reset
                                    </Button>
                                </Space>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
                <Table bordered title={title} loading={loading} has_data={has_data} columns={columns} dataSource={searchResult.results} size="middle" sticky={true} pagination={pagination} onChange={this.onTableChange} className="search-result-table" />
            </React.Fragment>
        )
    }
}

export default SearchGwas
